module.exports = __webpack_public_path__ + "img/logo_no_text.cf65ab7e.png";